import React from 'react';
import PropTypes from 'prop-types'
import {connect} from 'react-redux';

import {
  NitroLoading,
  NitroButton,
  NitroButtonGroup,
} from 'nitro-components';

import SectionHeader, {
  LeftSection,
  RightSection
} from '../../../components/layouts/SectionHeader';

import Container from "../../../components/layouts/Container";

import {
  ReportHeader,
  Source,
  Fields,
  Filters,
  Schedule
} from '../new-report/Summary/Sections';

import NewReport from '../new-report';

import SummarySection from '../new-report/Summary/SummarySection';

import NavBar from '../new-report/NavBar';
import DeleteConfirm from './components/DeleteConfirm';

import * as routes from "../../../routes/const";


const titles = [
  {
    title: "Data source",
    step: 0,
    Component: Source
  },
  {
    title: "Selected fields",
    step: 1,
    Component: Fields
  },
  {
    title: "Condition filters",
    step: 2,
    Component: Filters
  },
  {
    title: "Schedule",
    step: 4,
    Component: Schedule
  }
];

class NewEditReport extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      fetchingReports: true,
      fetchingReportFields: true,
      isOpen: false,
      wizardStep: -1,
      businessReportId: '',
    }
  }

  componentWillMount() {
    this.fetchReports();
    this.fetchReportFields();
    this.props.actions.setUserReport({reportId: this.props.reportId});
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.fetchingReports !== this.state.fetchingReports ||
      nextProps.fetchingReportFields !== this.state.fetchingReportFields ) {
        this.setState({
          fetchingReports: nextProps.fetchingReports,
          fetchingReportFields: nextProps.fetchingReportFields
        });
    }

    if(nextProps.businessReportId &&
      (nextProps.businessReportId !== this.state.businessReportId)) {
      this.props.actions.setBusinessReport({value: nextProps.businessReportId});
      this.setState({businessReportId: nextProps.businessReportId })
    }

    if(nextProps.countryCode && nextProps.companyCode) {
      const {
        countryCode,
        countryName,
        companyCode,
        companyCodeName,
      } = nextProps;

      this.props.actions.setCountry({
        label: countryName,
        value: countryCode
      });
      this.props.actions.setCostcenter({
        label: companyCodeName,
        value: companyCode
      });
    }
  }

  reloadState = () => {
    this.fetchReportFields();
  }

  open = (step) => {
    this.setState({isOpen: true, wizardStep: step});
  };

  close = () => {
    this.reloadState();
    this.setState({isOpen: false, wizardStep: -1});
  }

  postUpdate = () => {
    this.close();
    this.props.notify({
      title: "Success",
      message: "You have successfully update this report."
    });
  }

  fetchReportFields = () => {
    const { reportId, reportCategory, actions, notify } = this.props;
    actions.fetchReportFields(reportId, reportCategory).then(code => {
      if (code === 401) {
        notify({
          type: "error",
          title: "Error",
          message: "Not authorised to access this report."
        });
      }
    });
  }

  fetchReports = () => {
    if(this.props.reports.length === 0){
      this.props.actions.fetchReports()
    }
  }

  deleteReport = () => {
    const { router } = this.context;
    const { actions, notify } = this.props;

    actions.deleteReport(this.props.reportId).then(() => {
      const route = routes.RB_MY_REPORTS;

      notify({
        title: "Success",
        message: "Report has been deleted."
      });

      router.push(route);
    });

    this.props.toggleDeleteDialog();
  }


  exportReport = () => {
    const { reportId, reportName, countryCode, companyCode, businessReportId } = this.props;
    const params = {
      id: reportId,
      title: reportName,
      category: 'user',
      companyCode,
      countryCode,
      businessReportId
    };
    this.props.actions.exportReport(params);
  }

  cloneReport = () => {
    const { router } = this.context;

    const { reportId, reportName, reportDescription, notify } = this.props;

    const params = {
      id: reportId,
      title: reportName + ' - CLONED',
      description: reportDescription
    };

    this.props.actions.cloneReport(params).then((data) => {
      const newReport = data.value.data;

      notify({
        title: "Success",
        message: "Report has been cloned."
      });

      router.push(routes.RB_MY_REPORTS);

      // const route = `${routes.REPORTS_BUILDER}/user/${newReport.Id}`;
      // router.push(route);
    });
  }



  openEditPanel = (step) => {
    this.open(step);
  }

  editDetails = () => {
    this.openEditPanel(3);
  }

  render() {
    const {
      reportId,
      reportName,
      reportDescription,
      reportCategory,
      isDeleteDialogOpen,
      toggleDeleteDialog,
    } = this.props;

    const {
      fetchingReports,
      fetchingReportFields,
      wizardStep,
    } = this.state;

    const navComps = {
      left:(
        <NitroButtonGroup layout="horizontal" align="right">
          <NitroButton
            outlined
            action={toggleDeleteDialog}
            leftIcon="delete"
            label="Delete"
            size="extraSmall"
            leftIconVariant="base2"
            insideIconSize={8}
          />

          <NitroButton
            outlined
            action={this.cloneReport}
            label="Duplicate Report"
            leftIcon="save-as"
            size="extraSmall"
            leftIconVariant="base2"
            insideIconSize={8}
          />
        </NitroButtonGroup>
      ),
      right: (
        <NitroButton
          outlined
          action={this.exportReport}
          label="Export"
          leftIcon="export"
          size="extraSmall"
          leftIconVariant="base2"
          insideIconSize={8}
        />
      )
    };

    const nav = {
      goNext: () => {},
      goPrevious: () => {},
      currentStep: -1
    }

    if (fetchingReports || fetchingReportFields)
      return <NitroLoading center />

    return(
      <section>
        <ReportHeader
          reportName={reportName}
          reportDescription={reportDescription}
          editAction={this.editDetails} />
        <Container>
          <NewReport
            reportId={reportId}
            isOpen={this.state.isOpen}
            category={reportCategory}
            postUpdate={this.postUpdate}
            directStep={wizardStep}
            close={this.close}
            isEditMode={true} />


          {titles.map(({ title, step, Component }) => (
            <SummarySection
              key={title}
              title={title}
              step={step}
              action={this.openEditPanel}
            >
              <Component
                step={step}
                goToStep={this.openEditPanel}
              />
            </SummarySection>
          ))}

          <NavBar navigation={nav} navigationComponent={navComps} />

          <DeleteConfirm
            isOpen={isDeleteDialogOpen}
            action={this.deleteReport}
            onCancel={toggleDeleteDialog}
          />

        </Container>
      </section>
    )
  }
}

NewEditReport.propTypes = {
  actions: PropTypes.object,
  businessReportId: PropTypes.string,
  reportId: PropTypes.string,
  reportName: PropTypes.string,
  reportDescription: PropTypes.string,
  fetchingReportFields: PropTypes.bool,
  reports: PropTypes.array,
  toggleDeleteDialog: PropTypes.func
}

NewEditReport.contextTypes = {
  router: PropTypes.object
};

export default NewEditReport;



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/NewEditReport.js